import { formatCurrency } from "@/utils";
import { Flex, Text } from "@chakra-ui/react";

interface ValueProps {
    isChargeback?: boolean
    creditOperation?: boolean;
    isRefund?: boolean;
    isTax?: boolean;
    amount?: number;
    statementType?: string;
}
export function Value({creditOperation = true, amount = 0, isChargeback = false, isRefund = false, isTax = false, statementType = ""}: ValueProps) {
    return (
        <Flex position="relative">
            {creditOperation ?
                (<Text
                    fontSize="sm"
                    fontWeight={500}
                    color="var(--content-secondary)"
                    position="absolute"
                    left="-14px"
                    display={isTax ? "" : "none"}
                >
                    +
                </Text>
                ) :
                (
                    <Text
                        fontSize="sm"
                        fontWeight={500}
                        color="var(--content-secondary)"
                        position="absolute"
                        left="-6px"

                    >
                        -
                    </Text>
                )
            }
            {(creditOperation && statementType !== "DEBIT_TRANSFER") && (
                <Text
                    fontSize="sm"
                    textDecor={(isChargeback || isRefund || statementType === "CREDIT_ANTICIPATED" || statementType === "DEBIT_ANTICIPATED") && "line-through"}
                    fontWeight={500}
                    color="var(--content-secondary)"
                >
                    {formatCurrency({value: amount})}
                </Text>
            )}
            {(!creditOperation && statementType !== "DEBIT_TRANSFER") && (
                <Text
                    fontSize="sm"
                    textDecor={(isChargeback || isRefund || statementType === "CREDIT_ANTICIPATED" || statementType === "DEBIT_ANTICIPATED") && "line-through"}
                    fontWeight={500}
                    color="var(--accent-red)"
                >
                    {formatCurrency({value: amount})}
                </Text>
            )}
            {statementType === "DEBIT_TRANSFER" && (
                <Text
                    fontSize="sm"
                    textDecor={(isChargeback || isRefund) && "line-through"}
                    fontWeight={500}
                    color="var(--accent-green)"
                >
                    {formatCurrency({value: amount})}
                </Text>
            )}
        </Flex>
    )
}